import { inject } from '@angular/core';

import { map, take } from 'rxjs';

import { AuthRestaurantService } from '@tablesready/frontend-store';
import { PricePlansRestrictionsService } from '@tablesready/frontend-restrictions';
import { FrontendPaidFeatureService } from '@tablesready/frontend-paid-feature-alert';

export const businessPlanGuard = () => {
  const authRestaurantService = inject(AuthRestaurantService);
  const pricePlansRestrictionsService = inject(PricePlansRestrictionsService);
  const paidFeatureService = inject(FrontendPaidFeatureService);

  const user = authRestaurantService.get();
  const isLocationOnBusinessPlan = pricePlansRestrictionsService.availableForBusinessPlan(user.account.subscriptionType, user.location.recurly);

  if (!isLocationOnBusinessPlan) {
    return paidFeatureService.freePlanLocationModalDisplay(user, false)
      .pipe(
        take(1),
        map(() => false),
      );
  }

  return true;
};
